var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "details" },
    [
      _c("detail", {
        attrs: {
          prop: "Base amount",
          value:
            _vm.roundCurrency(_vm.tx.baseAmount, _vm.tx.baseAssetCode) +
            " " +
            _vm.tx.baseAssetCode
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: "Quote amount",
          value:
            _vm.roundCurrency(_vm.tx.quoteAmount, _vm.tx.quoteAssetCode) +
            " " +
            _vm.tx.quoteAssetCode
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: "Order",
          value: _vm.tx.isBuy
            ? _vm.i18n.trd_order_buy()
            : _vm.i18n.trd_order_sell()
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: "Price",
          value:
            _vm.roundCurrency(_vm.tx.price, _vm.tx.quoteAssetCode) +
            " " +
            _vm.tx.quoteAssetCode
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: {
          prop: "Fee",
          value:
            _vm.roundCurrency(_vm.tx.fee, _vm.tx.baseAssetCode) +
            " " +
            _vm.tx.baseAssetCode
        }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: "Date", value: _vm.i18n.d(_vm.tx.createdAt) }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "btn-wrap margin-top" },
        [
          _c(
            "md-button",
            {
              staticClass: "btn md-primary",
              attrs: { disabled: _vm.isPending },
              on: { click: _vm.cancelOffer }
            },
            [_vm._v("Cancel order")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ed5fde4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ed5fde4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/trade/index/components/manageOrders/ManageOrders.OrderDetails.vue
// module id = S+gY
// module chunks = 1